import { useCurrentAccountStore } from "@/stores/currentAccount"
import { IAccount } from "@/models/account/account.types"
import { computed, ref } from "vue"
import { useRouter } from "vue-router"
import { RouteNames } from "@/types/router"

export const useActiveAccountFlow = () => {
  const router = useRouter()
  const current = useCurrentAccountStore()
  const isExitWorkflowModalOpen = ref(false)

  const accountStatus = computed(() => current.account?.data.status.text)
  const accountStatusFormatted = computed(() =>
    accountStatus.value?.toLowerCase().split("_").join(" "),
  )
  const activeAccountNumber = computed(() => {
    const activeAccounts = current.supplyAddressAccounts
    const activeAccount = activeAccounts.data.filter(
      (account: IAccount) => !account.endDate,
    )

    if (activeAccount.length > 0) {
      return activeAccount[0]?.number
    }

    return undefined
  })

  const isLoading = computed(
    () =>
      (current.account?.isLoading && !activeAccountNumber.value) ||
      current.renewalPeriod.isFetching,
  )

  const closeFlow = () => {
    isExitWorkflowModalOpen.value = true
  }

  const closeFlowConfirm = () => {
    isExitWorkflowModalOpen.value = false
    router.push({ name: RouteNames.CustomerOverview })
  }

  return {
    current,
    accountStatus,
    accountStatusFormatted,
    activeAccountNumber,
    isExitWorkflowModalOpen,
    isLoading,
    closeFlowConfirm,
    closeFlow,
  }
}
